
import React, { Component } from 'react'
import resl from 'resl'
import app_cs from './App.module.css'
import position_cs from './components/map.module.css'
import Home from './components/home'
import Map from './components/map'
import $ from 'jquery'

import gsap from 'gsap';
import "./index.css"


window.jwplayer.key="44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK"

const is_mobile = window.innerWidth < 800

const yearMap =['History','1991','1994','1999','2004','2008','2009','2013','2014','2019','2022'];

const positionMap ={
    0:position_cs['infoWrapper'],
    1:position_cs['content_para_1991'],
    2:position_cs['content_para_1994'],
    3:position_cs['content_para_1999'],
    4:position_cs['content_para_2004'],
    5:position_cs['content_para_2008'],
    6:position_cs['content_para_2009'],
    7:position_cs['content_para_2013'],
    8:position_cs['content_para_2014'],
    9:position_cs['content_para_2019'],
    10:position_cs['content_para_2022']
};

class App extends Component {
    constructor(props) {
        super(props);
        this.state={
            yearIndex:null,
        }
    }

    componentDidMount() {
        //resize event may made multiple scroll trigger error, solve that problem
        $(window).resize(function() {
            gsap.to(window, {duration: 0, scrollTo: {y: "."+app_cs['main'], offsetY:0}});
            $('.'+position_cs['background-image']).css({opacity:0});
            $('.'+app_cs['yearAxis']).css({transform:`translate(0, 0)`});
        });
    }

    changeYear=(yearIndex)=>{
        this.setState({
            yearIndex:yearIndex
        })
    }

    scrollToPosition=(yearIndex)=>{
            $('.'+position_cs['background-image']).css({opacity:0});
            gsap.to(window, {duration: 1, scrollTo: {y: "."+positionMap[yearIndex], offsetY:-10}});
    }


   render() {
        let _self = this;
        let axisMove =  parseInt(this.state.yearIndex) * (6.625+4.01) + 'vw';

       return (<div className={app_cs['main']}>
           <div className='pc-title-wrape'>
                <span className='pc-title-brand'>CGTN</span>
                <a className='pc-title-conflict' href="https://news.cgtn.com/event/2022/Russia-Ukraine-Conflict-Tracker/index.html">
                   Conflict Tracker
                </a>
                <a className='pc-title-change' href='https://news.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis-CN/index.html'>EN <span>/中文</span></a>
           </div>
           <Home />
           <Map changeYear={this.changeYear}/>
           <div className={app_cs['yearAxisWindow']}>
               <ul className={app_cs['yearAxis']} style={{transform:`translate(-${axisMove}, 0)`}}>
                   {
                       yearMap.map(function (item,index) {
                           return  <li onClick={(e)=>_self.scrollToPosition(index)} className={index == _self.state.yearIndex ? app_cs['yearAxisItem'] + ' ' + app_cs['active'] :app_cs['yearAxisItem']} key={index}>
                               <div className={app_cs['yearAxisItemTop']}>{item}</div>
                               <div className={app_cs['yearAxisItemBottom']}></div>
                           </li>
                       })
                   }

               </ul>
           </div>
       </div>)
   }
}

export default App;
